module.exports = __webpack_public_path__ + "static/media/filter_circle_outline.3dd2735e.svg";